(function($){
	$(document).ready(function(){
		if( $('._inline-form').length ) {
			console.log('._inline-form');
			$('._inline-form').each(function(){
				$(this).find('._form-content').find('._form_element').each(function(){
					var fe = $(this);
					var field = fe.find('input, textarea');
					var select = fe.find('select'); 
					if ( field || select ) {
						if ( select ) {
							select.closest('._form_element').addClass('_select-wrap');
							field = select;
						}
						field.on('focus',function(){
							field.closest('._form_element').find('label').css({'top':'-16px','color':'white'}).delay(2000).fadeOut(2000);
						});
						field.on('blur',function(){
							console.log(field[0].validity);
							if ( field.val() == '' ){
								field.closest('._form_element').find('label').attr('style','').fadeIn(1000);
							}
							// if ( field[0].validity.valid ) { 
							// 	field.removeClass('invalid');
							// 	field.addClass('valid'); 
							// } else {
							// 	field.removeClass('valid');
							// 	field.addClass('invalid'); 
							// }
						});
					}
				});
			});
		}
	});
})(jQuery);